/*global VeloxGridAndFormController, VeloxWebView*/
var uuid = require("uuid") ;
var pkg = require("../../../package.json") ;

var domainController = new VeloxGridAndFormController("domain", {
    grid : {
        directory: "views/domain",
        name: "domainGrid",
        joinFetch : [
            { otherTable: "velox_user", thisField: "do_code", otherField: "uid", name: "user"}
        ]
    },
    form : {
        directory: "views/domain",
        name: "domainForm",
        joinFetch : [
            { otherTable: "velox_user", thisField: "do_code", otherField: "uid", name: "user"}
        ]
    },
});

domainController.formController.checkBeforeDelete = function(record, callback){
    return callback(null, false) ;
} ;

/**
 * Delete the realm and user when delete a reseller
 * 
 * @param {object} record the record to delete
 * @param {*} callback 
 */
domainController.formController.getRecordsToDelete = function(record, callback){
    var records = [];
    if(!record.r_code){ return callback("wrong data") ; }
    records.push({action : "remove", table: "reseller", record : {do_code: record.do_code}}) ;
    records.push({action : "remove", table: "velox_user_realm", record : {code: record.do_code}}) ;
    callback(null, records) ;
} ;

domainController.formController.validations.push(function checkCodeUnique(validationData, callback){
    if(domainController.formController.mode !== "create"){ return callback() ;}
    domainController.formController.api.api.domain.searchFirst({do_code: validationData.data.do_code}, function(err, existingDomain){
        if(err){ return callback(err) ;}
        if(existingDomain){
            return callback(VeloxWebView.tr("domain.aDomainAlreadyExist")) ;
        }
        callback() ;
    }) ;
}) ;

/**
 * Save realm and user when save reseller 
 * 
 * @param {object} viewData the data input by user
 * @param {object} dataBeforeModif the record before user modification
 * @param {*} callback 
 */
domainController.formController.getRecordsToSave = function(viewData, dataBeforeModif, callback){
    var records = [] ;

    if(this.mode === "create"){
        records.push({
            table: "domain", action: "insert", record: viewData
        }) ;
        records.push({
            table: "velox_user_realm", action: "insert", record: {
                code: viewData.do_code, name: viewData.do_name
            }
        }) ;
        records.push({
            table: "velox_user", action: "insert", record: {
                uid: viewData.do_code, 
                login: viewData.do_code, 
                lang: "fr-FR", 
                email: viewData.user.email, 
                auth_type: "password", 
                disabled: false, 
                active: false,
                activation_token: uuid.v4(),
                name: viewData.do_name,
                profile_code: "ADMIN"
            }
        }) ;
        records.push({
            table: "velox_link_user_realm", action: "insert", record: {
                user_uid: viewData.do_code, 
                realm_code: viewData.do_code
            }
        }) ;
    } else {
        records.push({
            table: "domain", action: "update", record: viewData
        }) ;
        records.push({
            table: "velox_user", action: "update", record: {
                uid: viewData.do_code, 
                email: viewData.user.email, 
            }
        }) ;
    }

    callback(null, records) ;
};

domainController.gridController.onResendMailActive = 
domainController.formController.onResendMailActive = function(ev){
    var domain = ev.data.data ;
    var baseUrl = pkg.serverUrl ;

    if(process.env.MODE !== "production"){
        baseUrl = pkg.serverDev ;
        if(process.env.MODE === "test"){
            baseUrl = pkg.serverTest ;
        } else {
            if(process.env.DEVICE === "mobile"){
                baseUrl = pkg.serverDevMobile ;
            }
        }
    }
    VeloxWebView.longTask(function(done){
        VeloxWebView.getLangTr("fr-FR", function(err, trLang){

            var message = trLang("login.activationMessage", {
                link: baseUrl+"/goto?u="+encodeURIComponent("/#activate$"+domain.user.activation_token),
                link_download: baseUrl+"/goto?u="+encodeURIComponent("/#download")
            });
            message = '<div style="font-family: Arial; font-size: 11pt">'+message+'</div>' ;

            if(err){ return done(err) ; }
            this.api.api.transactionalChanges(
                [
                    {
                        table : "velox_mail",
                        record: {
                            uid: uuid.v4(),
                            realm_code: domain.r_code,
                            server_uid: "noreply", 
                            from_addr: "hydratest@analyse-piscine.com", 
                            to_addr: domain.user.email,
                            subject: trLang("login.activationSubject"),
                            text: message,
                            html: message,
                            status: "tosend",
                            schedule_type: "now",
                        }
                    }
                ], function(err){
                if(err){ return done(err) ;}
                VeloxWebView.info(VeloxWebView.tr("reseller.mailResent")) ;
                done() ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;


domainController.gridController.onSendMailDownload = 
domainController.formController.onSendMailDownload = function(ev){
    var reseller = ev.data.data ;
    var baseUrl = pkg.serverUrl ;
    if(process.env.MODE !== "production"){
        baseUrl = pkg.serverDev ;
        if(process.env.MODE === "test"){
            baseUrl = pkg.serverTest ;
        } else {
            if(process.env.DEVICE === "mobile"){
                baseUrl = pkg.serverDevMobile ;
            }
        }
    }
    VeloxWebView.longTask(function(done){
        VeloxWebView.getLangTr(reseller.r_lang, function(err, trLang){
            if(err){ return done(err) ;}
            var message = trLang("login.downloadMessage", {
                link_download: baseUrl+"/#download"
            });
            this.api.api.transactionalChanges(
                [
                    {
                        table : "velox_mail",
                        record: {
                            uid: uuid.v4(),
                            realm_code: reseller.r_code,
                            server_uid: "noreply", 
                            from_addr: "hydratest@analyse-piscine.com", 
                            to_addr: reseller.user.email,
                            subject: trLang("login.downloadMessageSubject"),
                            text: message,
                            html: message,
                            status: "tosend",
                            schedule_type: "now",
                        }
                    }
                ], function(err){
                if(err){ return done(err) ;}
                VeloxWebView.info(VeloxWebView.tr("reseller.mailSent")) ;
                done() ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

module.exports = domainController ;